import maxBy from 'lodash/maxBy'
import dayjs from 'dayjs'

/**
 * カレンダーを開いた場合にどの月のカレンダーを開くかを取得
 */
export const dummyStartDateForInitialMonth = ({
  budgetList, // 既に設定されている予算もしくは、予算申請のリスト
  formBudgetList, // 予算バルク申請フォーム内で入力されている予算のリスト
}) => {
  // カレンダーを開くときにフォーム内で設定されているlastのendTimeを取得
  const budgetRequestFormLastEndDate =
    maxBy(formBudgetList, budgetRequest => dayjs(budgetRequest.endTime).unix())
      .endTime ||
    dayjs()
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss')

  if (budgetList.length === 0) {
    // insertionOrderBudgetListがない場合
    return dayjs(budgetRequestFormLastEndDate)
      .add(1, 'day')
      .format('YYYY-MM-DD 00:00:00')
  }

  const budgetListLastEndDate = maxBy(budgetList, budgetItem =>
    dayjs(budgetItem.endTime).unix(),
  ).endTime

  // insertionOrderBudgetListの設定がある場合
  // insertionOrderBudgetList内の最終のendDateと申請中ののLastのendDateを取得
  const pendingBudgetRequestLastDate = (() => {
    const lastDate = maxBy(
      budgetList.filter(function(budgetItem) {
        // 新規案件の場合requestStatusが存在しないので、undefinedも含める
        return (
          budgetItem.latestRequest.requestStatus === 'waiting' ||
          budgetItem.latestRequest.requestStatus === undefined
        )
      }),
      budgetItem => dayjs(budgetItem.latestRequest.endTime).unix(),
    )

    if (lastDate === undefined) return undefined
    return lastDate.latestRequest.endTime
  })()

  return dayjs(
    maxBy(
      [
        budgetListLastEndDate,
        pendingBudgetRequestLastDate,
        budgetRequestFormLastEndDate,
      ],
      endTime => dayjs(endTime).unix(),
    ),
  )
    .add(1, 'day')
    .format('YYYY-MM-DD 00:00:00')
}
